export enum CabinetSummaryOptions {
  Id,
  DocumentTypes,
  CabinetReferences,
  DocumentLocation
}